export default __webpack_public_path__ + "img/cbjFlZcK.332e634e.svg";